import React, { DragEvent, useContext, useState } from "react";
import "./FileDrop.css";
import { AuthContext } from "../../../../../contexts";
import { IFileDropModalProps } from "../../../../../@types/components/fileDropModal.types";
import { IAdminDocumentPayload } from "../../../../../@types/adminDocumentPayload.types";
import SearchIcon from "@material-ui/icons/Search";
import CompareArrowsSharpIcon from "@material-ui/icons/CompareArrowsSharp";
import styled from "styled-components";
import { api } from "../../../../../utils/api";
import { Button, TextField } from "@material-ui/core";
import File from "../file/File";

const FileDrop = ({ handleChangeSetFile, handleClose }: IFileDropModalProps) => {
	const [isOver, setIsOver] = useState(false);
	const [isFileSelected, setIsFileSelected] = useState<boolean>(false);
	const [selectedFile, setSelectedFile] = useState<File | null>(null);
	const [icon, setIcon] = useState<React.ReactNode>(<SearchIcon />);
	const [buttonTxt, setButtonTxt] = useState<string>("Browse");
	const [adminPayload, setAdminPayload] = useState<IAdminDocumentPayload>({
		document_date: new Date(),
		document_purpose: "",
		group_owner_object_id: "",
		parent_folder_id: "",
		root_folder_id: "",
		SSN: ""
	});

	// Define the event handlers
	const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		setIsOver(true);
	};

	const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		setIsOver(false);
	};

	const handleDrop = (event: DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		setIsFileSelected(true);
		setIsOver(false);
		setButtonTxt("replace");
		setIcon(<CompareArrowsSharpIcon />);
		// Fetch the files
		const droppedFiles = Array.from(event.dataTransfer.files);
		setSelectedFile(droppedFiles[0]);

		// eslint-disable-next-line prettier/prettier
		// eslint-disable-next-line arrow-parens
		droppedFiles.forEach((file) => {
			const reader = new FileReader();

			reader.onloadend = () => {
				// console.log("file uploaded");
			};

			reader.onerror = () => {
				console.error("There was an issue reading the file.");
			};

			reader.readAsDataURL(file);
			return reader;
		});
	};

	const handleChangeBrowseFile = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { files } = event.target;
		if (files) {
			// console.log("files");
			setIsFileSelected(true);
			setIsOver(false);
			setSelectedFile(files[0]);
			setButtonTxt("replace");
			setIcon(<CompareArrowsSharpIcon />);
		}
	};

	// const renameFile = (file: File, newFileName: string): File => {
	// 	const newBlob = new Blob([file], { type: file.type });
	// 	const renamedFile: File = new File([newBlob], newFileName, { type: file.type });
	// 	return renamedFile;
	// };

	const handleChangeSelectedFileName = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { value } = event.target;
		setSelectedFile(Object.assign({}, selectedFile, { name: value }));
	};

	const handleChnagePurpose = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { value } = event.target;
		setAdminPayload(Object.assign({}, adminPayload, { document_purpose: value }));
	};

	const handleDownload = (file: File) => {
		const url = URL.createObjectURL(file);
		const a = document.createElement("a");
		a.href = url;
		a.download = file.name;
		a.click();
		URL.revokeObjectURL(url);
	};

	const handleUploadFile = async () => {
		if (selectedFile) {
			handleChangeSetFile(selectedFile);
			handleClose();
		}
	};

	const VisuallyHiddenInput = styled("input")({
		clip: "rect(0 0 0 0)",
		clipPath: "inset(50%)",
		height: 1,
		overflow: "hidden",
		position: "absolute",
		bottom: 0,
		left: 0,
		whiteSpace: "nowrap",
		width: 1
	});

	return (
		<>
			<div
				onDragOver={handleDragOver}
				onDragLeave={handleDragLeave}
				onDrop={handleDrop}
				className="container"
				style={{
					backgroundColor: isOver ? "lightgray" : "white"
				}}
			>
				{!isFileSelected ? (
					<div style={{ margin: "auto", textAlign: "center" }}>
						<p>
							Drag & Drop Files to upload
							<br />
							Or
						</p>
					</div>
				) : (
					<>
						{selectedFile ? (
							<div className="item" onDoubleClick={() => handleDownload(selectedFile)}>
								<File name={selectedFile.name} />
							</div>
						) : null}
					</>
				)}
				<Button
					component="label"
					variant="contained"
					style={{ backgroundColor: "#44b700", color: "whiteß" }}
					className="browseFile"
					startIcon={icon}
				>
					{buttonTxt} File
					<VisuallyHiddenInput
						type="file"
						multiple={false}
						// eslint-disable-next-line prettier/prettier
						// eslint-disable-next-line arrow-parens
						onChange={(e) => handleChangeBrowseFile(e)}
					/>
				</Button>
			</div>
			<div className="button-container">
				{isFileSelected ? (
					<div className="input-container">
						<div className="save_purpose">
							<p>Save As :</p>
							{selectedFile ? (
								<TextField
									id="outlined-basic"
									variant="standard"
									label={""}
									value={selectedFile.name}
									// eslint-disable-next-line prettier/prettier
									// eslint-disable-next-line arrow-parens
									onChange={(e) => handleChangeSelectedFileName(e)}
								/>
							) : null}
						</div>
						<div className="save_purpose">
							<p>Purpose :</p>
							<TextField
								id="outlined-basic"
								variant="standard"
								label={""}
								// eslint-disable-next-line prettier/prettier
								// eslint-disable-next-line arrow-parens
								onChange={(e) => handleChnagePurpose(e)}
							/>
						</div>
					</div>
				) : null}
				<Button
					component="label"
					variant="contained"
					className=""
					disabled={!selectedFile}
					style={{ backgroundColor: "#44b700", color: "white" }}
					onClick={handleUploadFile}
				>
					<span style={{ marginRight: "10px" }}>
						<i className={"fas fa-upload menu-item-icon"} />
					</span>
					Upload Files
				</Button>
			</div>
		</>
	);
};

export default FileDrop;
